import { breakpoints, spaces } from '@99designs/common/core/settings';
import { Package } from '__generated__/Package';
import Heading from 'common/components/Heading';
import { Currency } from 'common/utils/currency';
import Stack from 'projects/libs/core-components/Stack/Stack';
import React from 'react';
import styled from 'styled-components';
import Price from './Price';

export interface Props {
    package: Package;
}

const Card = styled.div`
    width: 375px;
    padding: ${spaces.space8}px;
    border-radius: ${spaces.space4}px;
    box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.1);

    @media screen and (max-width: ${breakpoints.small[1]}px) {
        width: 100%;
        padding: ${spaces.space10}px;
    }
`;

const BriefPackage = ({ package: pkg }: Props) => {
    const price = pkg.price.earnings + pkg.price.fees;

    return (
        <Card data-testid={`package:${pkg.key}`}>
            <Stack space="space5">
                <Heading size={'h5'} margin={'no'}>
                    {pkg.view.title}
                </Heading>
                <Price amount={price} currency={pkg.price.currency as Currency} />
            </Stack>
        </Card>
    );
};

export default BriefPackage;
